import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation CreateMosaicAction(
    $tenantId: ID!
    $zoneId: ID!
    $input: MosaicActionInput!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        mosaicDev {
          createAction(input: $input)
        }
      }
    }
  }
`

export const executor = graphql.createExecutor<
  graphql.schema.CreateMosaicActionMutation,
  undefined,
  graphql.schema.CreateMosaicActionMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
